import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const CTA: React.FC = () => (
  <section className="bg-[#07110d] py-14 text-white md:py-16">
    <div className="mx-auto flex max-w-[1240px] flex-col gap-8 px-5 sm:px-8 md:flex-row md:items-end md:justify-between lg:px-10">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#85f6aa]">Certy para Windows</p>
        <h2 className="mt-5 max-w-[15ch] text-4xl font-semibold leading-[1] tracking-[-0.045em] md:text-5xl">Comprueba cómo funciona con tus certificados.</h2>
        <p className="mt-5 max-w-[52ch] text-base leading-7 text-[#c9d7ce]">Descarga la aplicación y verifica que reconoce los certificados instalados en tu equipo.</p>
      </div>
      <div className="flex shrink-0">
        <Link to="/downloads" className="editorial-button editorial-button-primary">Descargar Certy <ArrowRight className="h-4 w-4" /></Link>
      </div>
    </div>
  </section>
);

export default CTA;
